import { render, staticRenderFns } from "./reason.vue?vue&type=template&id=d4169b42&scoped=true"
import script from "./reason.vue?vue&type=script&lang=js"
export * from "./reason.vue?vue&type=script&lang=js"
import style0 from "./reason.vue?vue&type=style&index=0&id=d4169b42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4169b42",
  null
  
)

export default component.exports